export default __webpack_public_path__ + "static/media/e_wdt_c_5.0fa1e793.mp3";